export const verticalResizeEventName = (resizableContainerName) => `event:${resizableContainerName}:resize`;
